"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _CheckCircle["default"];
  }
});

var _CheckCircle = _interopRequireDefault(require("../lib/icons/legacy/CheckCircle"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
